export const isOnAdminSide = (location) => {
    return location.pathname.split('/')[1] === 'admin';
};
